export default __webpack_public_path__ + "static/media/7-internacional.f6cffa70.svg";